import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/contacts';

export default {

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, startupId, ecosystemId, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}&startup_id=${startupId}&ecosystem_id=${ecosystemId}`, data)
    },

    togglePrimary(id) {
        return axios.get(`${RESOURCE_NAME}/toggle-primary?id=${id}`)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-contact?id=${id}`)
    },

    getRocketReachInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-rocket-reach-info?id=${id}`)
    }
}
